import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import Header from '../components/Headers/Header'
import CustomLoader from '../components/Loader/CustomLoader'
import { useQuery, useMutation, gql, useApolloClient } from '@apollo/client'
import { deletecsadmin, getallworker, updateWorkerIsActiveById } from '../apollo'
import DataTable from 'react-data-table-component'
import orderBy from 'lodash/orderBy'
import { customStyles } from '../utils/manageLocalUsersTable'
import useGlobalStyles from '../utils/globalStyles'
import TableHeader from '../components/TableHeader'
import {
  Container,
  Button,
  Grid,
  Modal,
  MenuItem,
  IconButton,
  Menu,
  ListItemIcon,
  Typography,
  Paper,
  Box,
  Switch
} from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import { Icon } from '@iconify/react';
import AddLocalLocal from '../components/AddLocalUsers/AddLocalLocal'

const GET_ALL_LOCAL_ADMIN = gql`
${getallworker}
`
const DELETE_CSADMIN = gql`
${deletecsadmin}`

const UPDATE_WORKER_ACTIVE_STATUS = gql`
${updateWorkerIsActiveById}
`
const ManageLocalUsers = props => {
  const { t } = props
  const client = useApolloClient();
  const [editModal, setEditModal] = useState(false)
  const [addVendorModal, setAddVendorModal] = useState(false)
  const [vendors, setVendor] = useState(null)
  const userType = JSON.parse(localStorage.getItem('user-native'))
  const { data, error: errorQuery, loading: loadingQuery, refetch } = useQuery(
    GET_ALL_LOCAL_ADMIN, {
    fetchPolicy: 'network-only',
    variables: {
      storeId: userType.storeId
    },
    onError: error => {
      const isForbiddenError = error && error.graphQLErrors.some(err => err.extensions.code === 'FORBIDDEN');

      if (isForbiddenError) {
        localStorage.removeItem('user-native');
        localStorage.removeItem('restaurant_id');
        client.clearStore();
        props.history.push('/auth/login');
      }
    },
  })
  const [mutate] = useMutation(DELETE_CSADMIN, {
    refetchQueries: [{ query: GET_ALL_LOCAL_ADMIN }]
  })
  const [updateWorkerIsActiveById] = useMutation(UPDATE_WORKER_ACTIVE_STATUS, {
    onCompleted: () => refetch(),
    onError: (err) => console.error(err.message),
  });

  const golbalClasses = useGlobalStyles()
  const closeEditModal = () => {
    setEditModal(false);
    // setAddVendorModal(false);
  };

  const openaAddVendorModal = () => {
    setAddVendorModal(true);
  };
  const closeAddVendorModal = () => {
    setAddVendorModal(false);
  };

  const handleToggleActive = async (row) => {
    try {
      await updateWorkerIsActiveById({
        variables: {
          workerId: row._id,
          isActive: !row.isActive,
        },
      });

      refetch();
    } catch (err) {
      console.error("Toggle Error:", err.message);
    }
  };

  const columns = [
    {
      name: "Sl No.",
      cell: (row, index) => <>{index + 1}</>,
    },
    {
      name: 'Name',
      sortable: true,
      selector: 'name',

      style: { cursor: 'pointer', minWidth: "200px" },
    },
    {
      name: 'Email',
      sortable: true,
      selector: 'email',
      style: { cursor: 'pointer', minWidth: "300px" },
    },
    {
      name: 'Phone',
      sortable: true,
      selector: 'phone',
    },
    {
      name: "Active Status",
      sortable: true,
      center: true,
      minWidth: "170px",
      cell: (row) => {

        const isActive =
          (row.active !== undefined && row.active !== null && row.active) ||
          (row.isActive !== undefined && row.isActive !== null && row.isActive) ||
          false;

        return (
          <Box sx={{ display: "flex", alignItems: "center", gap: "10px", whiteSpace: "nowrap" }}>
            <Typography
              variant="body2"
              style={{
                fontWeight: 600,
                color: isActive ? "green" : "red",
                whiteSpace: "nowrap",
              }}
            >
              {isActive ? "Active" : "Inactive"}
            </Typography>

            <Switch
              checked={isActive}
              onChange={() => handleToggleActive(row)}
              size="small"
            />
          </Box>
        );
      },
    },
    {
      name: "Availability",
      sortable: true,
      center: true,
      minWidth: "150px",
      cell: (row) => {
        const isActive =
          (row.active !== undefined && row.active !== null && row.active) ||
          (row.isActive !== undefined && row.isActive !== null && row.isActive) ||
          false;
        const isAvailable = row.available === true;

        let label = "Deactivated";
        let color = "red";

        if (isActive && isAvailable) {
          label = "Available";
          color = "green";
        } else if (isActive) {
          label = "Unavailable";
          color = "#d97706";
        }

        return (
          <Typography
            variant="body2"
            style={{
              fontWeight: 600,
              color,
            }}
          >
            {label}
          </Typography>
        );
      },
    },



    {
      name: 'Action',
      cell: row => <>{actionButtons(row)}</>,
    },
  ]

  const customSort = (rows, field, direction) => {
    const handleField = row => {
      if (row[field]) {
        return row[field].toLowerCase()
      }
      return row[field]
    }

    return orderBy(rows, handleField, direction)
  }

  const handleSort = (column, sortDirection) => {

  }

  const filtered = data && data.getAllWorkersForLocalStore

  const globalClasses = useGlobalStyles()
  const toggleModal = vendor => {
    setEditModal(!editModal)
    setVendor(vendor)
  }

  const actionButtons = row => {
    const [anchorEl, setAnchorEl] = React.useState(null)
    const open = Boolean(anchorEl)
    const handleClick = event => {
      setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
      setAnchorEl(null)
    }
    return (
      <>

        <div>
          <IconButton
            aria-label="more"
            id="long-button"
            aria-haspopup="true"
            onClick={handleClick}>
            <MoreVertIcon fontSize="small" />
          </IconButton>
          <Paper>
            <Menu
              id="long-menu"
              MenuListProps={{
                'aria-labelledby': 'long-button'
              }}
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}>
              <MenuItem
                onClick={e => {
                  e.preventDefault()
                  setTimeout(() => {
                  }, 5000)
                  // uncomment this for paud version
                  toggleModal(row);
                }}
                style={{ height: 25 }}>
                <ListItemIcon>
                  <EditIcon fontSize="small" style={{ color: 'green' }} />
                </ListItemIcon>
                <Typography color="green">{t('Edit')}</Typography>
              </MenuItem>
              <MenuItem
                disabled
                onClick={e => {
                  e.preventDefault()
                  setTimeout(() => {
                  }, 5000)
                  // uncomment this for paud version
                  mutate({ variables: { adminId: row._id } });
                }}
                style={{ height: 25 }}>
                <ListItemIcon>
                  <DeleteIcon fontSize="small" style={{ color: 'red' }} />
                </ListItemIcon>
                <Typography color="red">{t('Delete')}</Typography>
              </MenuItem>
            </Menu>
          </Paper>
        </div>
      </>
    )
  }
  return (
    <>
      <Header />

      <Container classNname={globalClasses.flex} fluid>
        <Box sx={{ textAlign: 'right', mb: 3 }}>
          <Button

            className={golbalClasses.dashbordBtn}
            onClick={openaAddVendorModal}
          >
            <Icon icon="ic:twotone-plus" style={{ color: "white" }} />  {t('Add New Local User')}
          </Button>
        </Box>
        {addVendorModal ? <Grid container>
          {/* <Grid item xs={12} order={{ xs: 2, lg: 1 }}> */}
          <Grid
            sx={{ display: { xs: 'none', lg: 'block' } }}
            item
            mt={5}
            ml={-2}
            order={{ xs: 1, lg: 2 }}
          >
            <Modal
              open={addVendorModal}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              onClose={closeAddVendorModal}
            >
              <AddLocalLocal onClose={closeAddVendorModal} refetch={refetch} />
            </Modal>
          </Grid>  </Grid> : null}
        {errorQuery ? (
          <span>
            `${t('Error')}! ${errorQuery.message}`
          </span>
        ) : null}
        {loadingQuery ? (
          <CustomLoader />
        ) : (
          <DataTable
            subHeader={true}

            title={<TableHeader title={t('Manage Local Users')} />}
            columns={columns}
            data={filtered}
            pagination
            progressPending={loadingQuery}
            progressComponent={<CustomLoader />}
            onSort={handleSort}
            sortFunction={customSort}
            customStyles={customStyles}
            // selectableRows
            paginationIconLastPage=""
            paginationIconFirstPage=""
          />
        )}

        <Modal
          open={editModal}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          onClose={() => {
            toggleModal()
          }}>
          <AddLocalLocal vendor={vendors} editModal={editModal} onClose={closeEditModal} refetch={refetch} />
        </Modal>
      </Container>
    </>
  )
}
export default withTranslation()(ManageLocalUsers)
